import { getDashboardData } from "../helper/getDashboardData";

export const RoleCheck = (item) => {
    if (!item) return false;
    const { role = [], privilege = [], onlyForUsers = [] } = item;

    const dashboardData = getDashboardData();
    const currRole = dashboardData?.userType;
    const currPrivilege = dashboardData?.privileges || [];
    const isApiPartner = dashboardData?.isApiPartnerEnabled;

    if (isApiPartner) {
        return onlyForUsers.includes("STRICT_ACCESS_ONLY");
    }

    const hasRole = role.includes("ALL") || role.includes(currRole);
    const hasPrivilege = privilege.some((p) => currPrivilege.includes(p));

    return hasRole || hasPrivilege;
};